export const defaultUrlSuffix: string = 'aidddo'